import { render, staticRenderFns } from "./OperationAcademy.vue?vue&type=template&id=48416284&scoped=true"
import script from "./OperationAcademy.vue?vue&type=script&lang=js"
export * from "./OperationAcademy.vue?vue&type=script&lang=js"
import style0 from "./OperationAcademy.vue?vue&type=style&index=0&id=48416284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48416284",
  null
  
)

export default component.exports